import { runtimeConfig } from '@/shared/config'
import { client } from './__generated__/client.gen'
import { authTokenStore } from './auth-token'

// Пути спеки уже содержат /api-префикс, поэтому база — origin без него:
// '/api' → '', 'https://host/api' → 'https://host'.
const baseUrl = runtimeConfig.API_BASE_URL.replace(/\/api\/?$/, '')

client.setConfig({
  baseUrl,
  auth: () => authTokenStore.getState().token ?? undefined,
})

client.interceptors.response.use((response) => {
  if (response.status === 401) authTokenStore.getState().setToken(null)
  return response
})

export { client as apiClient }
